import StatusChip from "../components/statusChip/statusChip.component";
import ActionButton from "../components/tableActions/tableActions.component";
import { TYPE_COLORS } from "../utils/statusConstants";
import { actionsButtonsContainerSx } from "../styles/commonStyles";
import dayjs from "dayjs";

export const fieldColumns = (fieldActions) => [
  { field: "id", headerName: "ID" },
  {
    field: "fieldName",
    headerName: "Nome",
    flex: 0.12,
    minWidth: 100,
  },
  {
    field: "companyName",
    headerName: "Nome azienda",
    flex: 0.12,
    minWidth: 100,
  },
  {
    field: "date",
    headerName: "Data aggiunta",
    flex: 0.15,
    minWidth: 130,
  },
  {
    field: "type",
    headerName: "Tipologia",
    flex: 0.25,
    minWidth: 250,
    renderCell: (params) => (
      <div
        style={{
          display: "flex",
          gap: "8px",
          flexWrap: "wrap",
          height: "100%",
          alignItems: "center",
        }}
      >
        {(params.value || ["Default"]).map((type, index) => (
          <StatusChip key={index} status={type} colors={TYPE_COLORS} />
        ))}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "Azioni",
    flex: 0.06,
    minWidth: 150,
    renderCell: (params) => (
      <div style={actionsButtonsContainerSx}>
        {fieldActions.map((item, index) => {
          return (
            <ActionButton
              key={index}
              icon={item.icon}
              tooltip={item.tooltip}
              onClick={() => item.onClick(params.row.id)}
            />
          );
        })}
      </div>
    ),
  },
];

export const formatFieldsData = (fieldsData) => {
  if (!fieldsData) return [];

  return fieldsData.map((field) => ({
    id: field.id,
    fieldName: field.name,
    companyName: field.user.company_name,
    date: dayjs(field.user.date_joined).format("DD/MM/YYYY"),
    type: [field.field_type.name],
  }));
};
